export enum StorageVariable {
    ACCESS_TOKEN_KEY = 'access_token',
    REFRESH_TOKEN_KEY = 'refresh_token',
    TOKEN_EXPIRATION_KEY = 'access_token_expiration',
    ACTIVE_TABS_STORAGE_KEY = 'activeAppTabs',
    RUT_USUARIO = 'rut_usuario',
    RUT_EMPRESA = 'rut_empresa',
    SUCURSAL_CODIGO = 'sucursal_codigo',
    LATITUD = 'latitud',
    LONGITUD = 'longitud',
    USER_AGENT = 'user_agent',
    IP = 'ip',
}
